import React from 'react'
import { Typography } from 'antd'
const Exchanges = () => {
  return (
    <div>
      <Typography.Title>Dind't pay the subscription for this. Sorry!!</Typography.Title>
      
    </div>
  )
}

export default Exchanges
